<template>
  <a href="#" :class="{'primary-button': true, 'uppercase': uppercase}" @click.prevent="$emit('button-click')">{{label}}</a>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: ['label', 'uppercase']
}
</script>

<style scoped lang="scss">
.primary-button {
    display: inline-block;
    flex: 1;

    padding: 6px 20px 4px 20px;

    text-decoration: none !important;

    color: #fff;
    border-bottom: none !important;
    border-radius: 3px;
    background: url(https://brandogsikring.dk/files/layout/css/bg-button.png);
    background-size: auto 100%;

    font-size: 14px;
    font-weight: bold;
    &.uppercase {
        text-transform: uppercase;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PrimaryButton.vue